import React, { useState, useEffect, useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import "./CloudfrontVideoFormat.scss";
import ReactHlsPlayer from "react-hls-player";
import MediaService from "../services/MediaService";
import PopUp from './../Popup/logoutPopup'
import { getGPUTier } from 'detect-gpu'


const CloudfrontVideoFormat = ({
  onPlay,

  source,
  back,
  ended,
  controls = (!window.location.href.includes('wearefriends.cool')) ?  true : window.location.href.includes('staging') ? true : false,
  background,
  close,
}) => {
  const popUp = useRef();
  const timer = useRef();
  const timer1 = useRef();
  const timer2 = useRef();
  const ref = useRef(null);
  const endedGuard = useRef(false);
  // const controlBar = document.getElementById('controlBar')

  const [playing, setPlaying] = useState(true);
  const [link, setLink] = useState("");

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const ExitImage = MediaService.getImage("/Images/close.png", login);
  const PlayButton = MediaService.getImage(
    "/Images/Video play.png",
    login
  );

  // const [clientHeight, setVh] = useState(window.innerHeight);
  // const [clientWidth, setVw] = useState(window.innerWidth);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setVh(window.innerHeight);  
  //     setVw(window.innerWidth);
  //   };
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [clientHeight, clientWidth]);

  // useEffect(() => {
  //   if(clientWidth < 500) {
  //     setPhone(true)
  //   }
  //   else{
  //     setPhone(false)
  //   }
  // }, [clientWidth]);

  const saveVideoBtn = {
    border: 'transparent', 
    backgroundColor: 'transparent', 
    position: 'absolute', 
    left: '0',
    right: '0',
    margin: '0 auto',
    top: '45%',
    width: '60px',
    height: '60px',
    justifyContent: 'center',
    zIndex: 100,
};


const back10Sec = {
    border: 'transparent', 
    backgroundColor: 'transparent', 
    position: 'absolute',
    width: '60px',
    height: '60px', 
    left: '0',
    right: '0',
    margin: '0 auto',
    top: '55%',
    justifyContent: 'center',
    zIndex: 100,
};

  // const Replay = MediaService.getImage("/Images/rewind.png", login);

  // const handleMouseEnter = () => {
  //   document.getElementById('controlBar').style.display='block'
  // };
  // const handleMouseLeave = () => {
  //   document.getElementById('controlBar').style.display='none'
  // };

  useEffect(() => {
    (async () => {
      await getGPUTier().then((rel)=>{
        if (source && source.includes('m3u8')) {
          if(rel.gpu.includes('arm')){
            if(source.includes('480.m3u8')){
              source = source.replace('480.m3u8', '1080.m3u8');
            }
            else if(source.includes('360.m3u8')){
              source = source.replace('360.m3u8', '1080.m3u8');
            }
          }
          setLink(`${login.cloudFront}videos/${source}`);
    
        } else {
          if (source){
            if (source.includes('https://')) {
              setLink(source);
            }
            else{
              setLink(`${login.cloudFront}media/${source}?${login.cookie}`);
            }
          }
          else{
            if (!endedGuard.current) { endedGuard.current = true; ended(); }
          }
        }
      });
    })();
  },[]);

  useEffect(() => {
    if (!source || !source.includes('m3u8')) return;
    if (!ref.current) return;

    const video = ref.current;
    let lastTime = 0;
    const ua = navigator.userAgent || '';
    const isIOS = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!isIOS) return;
    const NEAR_END_S = isIOS ? 0.5 : 0.3;
    const STUCK_MS = isIOS ? 500 : 800;

    const finishIfNearEnd = () => {
      if (!isFinite(video.duration)) return;
      const nearEnd = (video.duration - video.currentTime) <= NEAR_END_S;
      if (!nearEnd) return;
      try {
        if (isIOS) {
          const target = Math.max(0, video.duration - 0.05);
          if (video.currentTime < target) {
            video.currentTime = target;
          }
        }
      } catch (e) {}
      if (!timer1.current) {
        timer1.current = setTimeout(() => {
          ended();
        }, STUCK_MS);
      }
    };

    const onTimeUpdate = () => {
      if (!isFinite(video.duration)) return;
      const nearEnd = (video.duration - video.currentTime) <= NEAR_END_S;
      const progressed = Math.abs(video.currentTime - lastTime) > 0.01;

      if (nearEnd) {
        if (progressed) {
          lastTime = video.currentTime;
          if (timer1.current) { clearTimeout(timer1.current); timer1.current = null; }
        } else {
          finishIfNearEnd();
        }
      } else {
        lastTime = video.currentTime;
        if (timer1.current) { clearTimeout(timer1.current); timer1.current = null; }
      }
    };

    const onPause = () => finishIfNearEnd();
    const onWaiting = () => finishIfNearEnd();
    const onStalled = () => finishIfNearEnd();

    const heartbeat = setInterval(() => {
      if (!ref.current) return;
      const v = ref.current;
      try {
        const hasDuration = isFinite(v.duration);
        const bufferedCount = v.buffered ? v.buffered.length : 0;
        const bufferedEnd = bufferedCount ? v.buffered.end(bufferedCount - 1) : 0;
        const deltaToBuffered = bufferedEnd - v.currentTime;
        const deltaToDuration = hasDuration ? (v.duration - v.currentTime) : Infinity;
        const nearBufferedEnd = deltaToBuffered <= 0.05;
        const nearDurationEnd = hasDuration && deltaToDuration <= NEAR_END_S;

        if ((nearDurationEnd || (!hasDuration && nearBufferedEnd)) && !endedGuard.current) {
          finishIfNearEnd();
        }
      } catch (e) {}
    }, 250);

    video.addEventListener('timeupdate', onTimeUpdate);
    video.addEventListener('pause', onPause);
    video.addEventListener('waiting', onWaiting);
    video.addEventListener('stalled', onStalled);
    return () => {
      video.removeEventListener('timeupdate', onTimeUpdate);
      video.removeEventListener('pause', onPause);
      video.removeEventListener('waiting', onWaiting);
      video.removeEventListener('stalled', onStalled);
      clearInterval(heartbeat);
      if (timer1.current) { clearTimeout(timer1.current); timer1.current = null; }
    };
  }, [source, ended]);

  return (
    <div className="player-container-old" style={{ backgroundImage: `url(${background}` }}>
      {/* <div className="videoDiv" onMouseEnter={() => document.getElementById('controlBar').style.opacity='1'} onMouseLeave={() => document.getElementById('controlBar').style.opacity='0'}> */}
      <div className="videoDiv">
        <img
          className="back-btn-ftb"
          src={ExitImage}
          onClick={() => (close())}
        />
        <div ref={popUp} style={{display: 'none'}}>
          <PopUp 
              content={
                <>
                  <b id='title'>
                      This video requires a faster internet connection. 
                      <br />
                      If it is still freezing after 15 seconds, we will skip it for you. 
                      <br />
                      You can always watch it later in the review mode.
                      <br />
                  </b>
                  <button
                    id="logoutButton1"
                    className="logoutButton"
                    onClick={() => {
                      popUp.current.style.display = 'none';
                    }}
                  >
                    <b id="title">
                      OKAY
                    </b>
                  </button>
                </>
              }
          />
        </div>
        {/* {source.includes('m3u8') && <div id="controlBar" >
            {<img style={saveVideoBtn} src={PlayButton} alt="PlayButton" onClick={() => {
                        if(ref.current.paused){
                            ref.current.play();
                        }
                        else{
                            ref.current.pause();
                        }
                }}>
            </img>}

            {<img style={back10Sec} src={Replay} alt="backSecondsButton" onClick={() => {
                if(ref.current.currentTime < 10) {
                    ref.current.currentTime = 0
                } else {
                    ref.current.currentTime = ref.current.currentTime - 10
                }
            }}>
            </img>}
        </div>}
        {!source.includes('m3u8') && <div id="controlBar">
            {<img style={saveVideoBtn} src={PlayButton} alt="PlayButton" onClick={() => {
                    if(!playing){
                        instrumentalPlayer.current.play();
                        recordPlayer.current.play();
                    }
                    else{
                        instrumentalPlayer.current.pause();
                        recordPlayer.current.pause();
                    }
                    setPlaying(!playing)
                }}>
            </img>}

            {<img style={back10Sec} src={Replay} alt="backSecondsButton" onClick={() => {
                if(ref.current.getCurrentTime() < 10) {
                    ref.current.seekTo(0);
                    recordPlayer.current.currentTime = 0
                    instrumentalPlayer.current.currentTime = 0
                } else {
                    ref.current.seekTo(ref.current.getCurrentTime()-10);
                    recordPlayer.current.currentTime = recordPlayer.current.currentTime - 10;
                    instrumentalPlayer.current.currentTime = instrumentalPlayer.current.currentTime - 10;
                }
            }}>
            </img>}
      </div>} */}
        </div>
        <div className="video-container-old">
          {source && !source.includes("m3u8") ? (
            <ReactPlayer
              controls={controls}
              className="react-player-old"
              ref={ref}
              playing={playing}
              url={link}
              onEnded={ended}
              onError={ended}
              onStart={onPlay}
              playsinline={true}
            />
          ) : (<ReactHlsPlayer
            className='hls-player'
            playerRef={ref}
            src={link}
            autoPlay={true}
            controls={controls}
            height="95%"
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            playsInline={true}
            onEnded={ended}
            onError={ended}
            preload="auto"
            onWaiting={() => {
              timer2.current = setTimeout(() => {
                popUp.current.style.display = 'block';    
              }, 5000);

              timer.current = setTimeout(() => {
                ended();
              }, 15000);
            }}
            onPlaying={() => {
              popUp.current.style.display = 'none';
              clearTimeout(timer.current);
              clearTimeout(timer2.current);
            }}
            hlsConfig={{
              capLevelToPlayerSize:true,
              capLevelOnFPSDrop: true,
              startLevel:-1,
              nudgeOffset: 0.1,
              nudgeMaxRetry: 10,
              maxSeekHole: 2,
              maxBufferLength: 30,
              maxBufferHole: 0.5,
              manifestLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: Infinity,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              playlistLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              fragLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 120000,
                  timeoutRetry: {
                    maxNumRetry: 4,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 6,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              keyLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 8000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 20000,
                    backoff: 'linear',
                  },
                  errorRetry: {
                    maxNumRetry: 8,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 20000,
                    backoff: 'linear',
                  },
                },
              },
              certLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 8000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              steeringManifestLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                }
              },
              xhrSetup: function(xhr, url) {
                if(window.location.href.includes('wearefriends.cool')){
                  xhr.withCredentials = true // send cookies
                }
                else{
                  xhr.open('GET', url + login.cookie);
                }
              }
            }}
          />)}
        </div>
    </div>
  );
};
export { CloudfrontVideoFormat };
